import CloseIcon from '@mui/icons-material/Close';
import KeyboardDoubleArrowRight from '@mui/icons-material/KeyboardDoubleArrowRight';
import Smartphone from '@mui/icons-material/Smartphone';
import { Box, Drawer as MuiDrawer, IconButton } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { MobileDrawerProps } from './MobileDrawer.props';
import { DrawerContent } from '../DrawerContent';

export const MobileDrawer: React.FC<MobileDrawerProps> = ({
  menuData,
  open,
  onOpen,
  onClose,
  onMenuItemClick,
  width,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <Box
        component="nav"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: 'v4.sidebar',
          px: 1,
        }}
      >
        <IconButton onClick={onOpen} sx={{ color: '#fff' }} aria-label="Open sidebar">
          <KeyboardDoubleArrowRight />
        </IconButton>
        <Box
          component="img"
          src="/images/leftMenu/Amtek_Logo_Phoenix_Single_White@0.5x.png"
          alt="Company logo"
          sx={{ height: 24 }}
        />
        {location.pathname === '/services' && (
          <IconButton
            onClick={() => navigate('/mobile/services')}
            sx={{ color: '#fff' }}
            aria-label="Mobile view"
          >
            <Smartphone />
          </IconButton>
        )}
      </Box>
      <MuiDrawer
        anchor="left"
        open={open}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            width,
            bgcolor: 'v4.sidebar',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 1, py: 0.5 }}>
          <IconButton onClick={onClose} sx={{ color: '#fff' }} aria-label="Close sidebar">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
          <DrawerContent menuData={menuData} handleMenuItemClick={onMenuItemClick} />
        </Box>
      </MuiDrawer>
    </>
  );
};
